import * as React from "react";
import {
    gql,
    useMutation,
    ApolloError
} from "@apollo/client";
import {
    UpdateOfferPointsDeductionMutationMutation,
    UpdateOfferPointsDeductionMutationMutationVariables
} from "../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";

export const updateOfferPointsDeductionMutation = gql`
  mutation UpdateOfferPointsDeductionMutation(
    $id: String!
    $point: Int!
  ) {
    updateOfferPointsDeduction(
      id: $id
      point: $point
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: UpdateOfferPointsDeductionMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const UpdateOfferPointsDeductionController: React.FC<Props> = ({ children, onMessage }) => {
  const [updateOfferPointsDeduction, { loading, error }] = useMutation<
    UpdateOfferPointsDeductionMutationMutation,
    UpdateOfferPointsDeductionMutationMutationVariables
  >(updateOfferPointsDeductionMutation);

  const submit = async (values: UpdateOfferPointsDeductionMutationMutationVariables) => {
    const { data } = await updateOfferPointsDeduction({
      variables: values,
    });

    const errors = data?.updateOfferPointsDeduction?.errors
      ? normalizeErrors(data.updateOfferPointsDeduction.errors)
      : null;
    const message = data?.updateOfferPointsDeduction?.message ?? undefined;

    if (message && onMessage) {
      onMessage(message);
    }

    return {
      errors,
      message,
    };
  };

  return children({ submit, loading, error });
};
